import { ReactElement } from 'react';
import ReactDom from 'react-dom';
import { FaTimes } from 'react-icons/fa';

interface ModalProps {
  children: ReactElement;
  isOpen: boolean;
  onClose: () => void;
}

export default function Modal({ children, isOpen, onClose }: ModalProps) {
  const portalElement = document.getElementById('portal');
  if (!portalElement) {
    return null;
  }

  const handleOverlayKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClose();
    }
  };

  return ReactDom.createPortal(
    <>
      <div
        onClick={onClose}
        onKeyDown={handleOverlayKeyDown}
        className={`modal-overlay ${isOpen ? 'open' : ''}`}
        role="button"
        tabIndex={isOpen ? 0 : -1}
        aria-label="Close modal"
      />
      <div className={`app-modal ${isOpen ? 'open' : ''}`}>
        <button onClick={onClose} className="close-btn" type="button">
          <FaTimes />
        </button>
        {children}
      </div>
    </>,
    portalElement
  );
}
